// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.see-more-video-card {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background-color: var(--color_neutral_100);
  border-radius: 8px;
}
.see-more-video-card:hover {
  background-color: var(--color_primary_100);
}
.see-more-video-card:hover h5 {
  color: var(--color_primary_500);
}
.see-more-video-card h5 {
  color: var(--color_neutral_800);
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/SeeMoreCard/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AACF;AACE;EACE,0CAAA;AACJ;AACI;EACE,+BAAA;AACN;AAGE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AADJ","sourcesContent":[".see-more-video-card {\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--color_neutral_100);\n  border-radius: 8px;\n\n  &:hover {\n    background-color: var(--color_primary_100);\n\n    h5 {\n      color: var(--color_primary_500);\n    }\n  }\n\n  h5 {\n    color: var(--color_neutral_800);\n    font-size: 14px;\n    font-weight: 400;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
